@if (security().securityId) {
  <div class="ap-container">
    <h2 class="ps-2">
      {{
        'portfolio.viewSecurity'
          | translate
            : {
                transactionType:
                  security().transactionType?.name?.toLowerCase(),
              }
      }}
    </h2>
    <div class="d-flex">
      <div class="col-12">
        <ap-panel class="shadow">
          <div class="ap-grid pt-4 mx-0">
            @if (security().entity) {
              <div class="d-grid g-col-12">
                <strong>{{ security().clientName }}</strong>
                <small>{{ 'portfolio.clientName' | translate }}</small>
              </div>
            }
            @if (!isSpecificAdviceTransactionType()) {
              <div class="d-grid g-col-sm-12 g-col-md-4">
                <strong>{{ security().generalRateEntityTypeName }}</strong>
                <small>{{ 'portfolio.entityType' | translate }}</small>
              </div>
            } @else {
              @if (security().entity) {
                <div class="d-grid g-col-sm-12 g-col-md-4">
                  <strong>{{ security().entity?.name }}</strong>
                  <small>{{ 'portfolio.investingEntity' | translate }}</small>
                </div>
              }
              @if (security().entity?.entityType) {
                <div class="d-grid g-col-sm-12 g-col-md-4">
                  <strong>{{ security().entity?.entityType?.name }}</strong>
                  <small>{{ 'portfolio.entityType' | translate }}</small>
                </div>
              }
            }
            @if (security().name) {
              <div class="d-grid g-col-sm-12 g-col-md-4">
                <strong>{{ security().name }}</strong>
                <small>{{ 'portfolio.securities.security' | translate }}</small>
              </div>
            }
            @if (
              isSpecificAdviceTransactionType() &&
              security().entity?.residencyJurisdiction
            ) {
              <div class="d-grid g-col-sm-12 g-col-md-4">
                <strong>{{
                  security().entity?.residencyJurisdiction?.country?.name
                }}</strong>
                <small>{{
                  'portfolio.residencyJurisdiction' | translate
                }}</small>
              </div>
            }
            @if (security().investmentJurisdiction) {
              <div class="d-grid g-col-sm-12 g-col-md-4">
                <strong>{{
                  security().investmentJurisdiction?.country?.name
                }}</strong>
                <small>{{
                  'portfolio.investmentJurisdiction' | translate
                }}</small>
              </div>
            }
            @if (security().securityType) {
              <div class="d-grid g-col-sm-12 g-col-md-4">
                <strong>{{ security().securityType?.name }}</strong>
                <small>{{ 'portfolio.securityType' | translate }}</small>
              </div>
            }
            @if (isSpecificAdviceTransactionType()) {
              @if (isSpecificAdviceTransactionType()) {
                @if (security().acquisitionDate) {
                  <div class="d-grid g-col-sm-12 g-col-md-4">
                    <strong>{{
                      security().acquisitionDate?.toLocaleDateString()
                    }}</strong>
                    <small>{{ 'portfolio.acquireDate' | translate }}</small>
                  </div>
                }
              }
            }
            @if (security().dispositionDate) {
              <div class="d-grid">
                <strong>{{
                  security().dispositionDate?.toLocaleDateString()
                }}</strong>
                <small>{{ 'portfolio.dispositionDate' | translate }}</small>
              </div>
            }
          </div>

          <hr class="mt-4 w-100" />

          <div class="d-flex mt-5">
            @if (isApproved()) {
              @for (item of groupTaxRatesByType(); track $index) {
                <div class="col-5">
                  <strong class="ap-font-24"
                    >{{ multipleRatesString(item[1]) }}%</strong
                  >
                  <hr class="mb-0 w-25" />
                  <p>
                    {{ item[1][0].transactionTypeName | parseToSentenceCase }}
                  </p>
                  <gstar-explanation-field [taxResultItem]="item[1]" />
                </div>
              }
            } @else if (isInformationRequired()) {
              <strong class="mx-auto my-5 white-space-pre text-center">
                {{ 'portfolio.informationRequiredStatus' | translate }}
              </strong>
            } @else {
              <strong class="mx-auto my-5">
                {{ 'portfolio.pendingApprovalStatus' | translate }}
              </strong>
            }
          </div>
          @if (security().comments && isApproved()) {
            <div class="d-flex my-3">
              <div class="col-12">
                <gstar-comment-field
                  [comment]="security().comments || ''"
                  [title]="
                    'portfolio.comments' | translate
                  "></gstar-comment-field>
              </div>
            </div>
          }
        </ap-panel>

        <div class="mt-3 d-flex justify-content-end">
          <ap-button
            (click)="redirectToPortfolio()"
            btnType="primary"
            [label]="backButtonText" />
        </div>
      </div>
    </div>
  </div>
}
